import { render, staticRenderFns } from "./PillBasic.vue?vue&type=template&id=6d04a3e6&"
import script from "./PillBasic.vue?vue&type=script&lang=js&"
export * from "./PillBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports